import { render, staticRenderFns } from "./ListArbos.vue?vue&type=template&id=40652584&"
import script from "./ListArbos.vue?vue&type=script&lang=js&"
export * from "./ListArbos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports